import React from 'react';
import { users } from 'types';
import DialogConfirm from 'components/dialog/dialog-confirm';
import { TDialogWrapperComponent } from 'components/dialog/index.types';
import LockIcon from '@material-ui/icons/Lock';
import { CellButtonContentStyled } from '../index.styled';
import useUserLock from '../hooks/use-user-lock';

const DialogLock = ({
    setIsDialogOpen,
    isDialogOpen,
    asyncStatesHandlers,
    data,
}: { data?: users.TUsersDetail } & TDialogWrapperComponent) => {
    const [onLock] = useUserLock(asyncStatesHandlers);

    return (
        <DialogConfirm<users.TUsers>
            isDialogOpen={!!data && isDialogOpen}
            setIsDialogOpen={setIsDialogOpen}
            title={<>Confirm user lock</>}
            labels={{
                onOk: (
                    <CellButtonContentStyled>
                        <LockIcon /> Lock
                    </CellButtonContentStyled>
                ),
            }}
            onOk={async () => {
                if (!data || !data.id) {
                    console.error('No ID');
                    return;
                }
                try {
                    await onLock({ id: data.id });
                } catch (e) {}
            }}
        />
    );
};

export default DialogLock;
